import React from 'react';

import type { LinkPreviewNode } from './../../ricos-schema/next-schema';
import type { Helpers, LinkPreviewData } from './../../ricos-types';
import { Node_Type } from './../../ricos-types';
import { Image } from './../../ui-components';

import { LINK_PREVIEW_VIEWER } from '../data-hooks';
import styles from '../statics/styles/link-preview-scss';
import { LINK_PREVIEW_TYPE } from '../types';

const startsWithHttps = (url: string) => /^https:/.test(url);

const startsWithHttp = (url: string) => /^http:/.test(url);

const getHost = (url?: string) =>
  !url
    ? url
    : !startsWithHttps(url) && !startsWithHttp(url)
    ? new URL(`http://${url}`).host
    : new URL(url).host;

export const LinkPreviewViewer: React.FC<{
  node: LinkPreviewNode;
  helpers?: Helpers;
}> = ({ node, helpers }) => {
  const linkPreviewStyles = styles;

  const getUrlForDisplay = (url: string) => url.replace(/^https?:\/\//, '');

  const onLinkPreviewClick = () => {
    if (node.type === 'LINK_PREVIEW') {
      helpers?.onViewerAction?.(
        LINK_PREVIEW_TYPE,
        'Click',
        node.linkPreviewData.link?.url || '',
        node.id,
        {
          type: Node_Type.LINK_PREVIEW,
          linkPreviewData: node.linkPreviewData as LinkPreviewData,
        }
      );
    }
  };

  const { title = '', description, thumbnailUrl, link } = node.linkPreviewData;
  const {
    linkPreviewContainer,
    linkPreview,
    linkPreviewUrl,
    linkPreviewInfo,
    linkPreviewTitle,
    linkPreviewImage,
    linkPreviewDescription,
  } = linkPreviewStyles;

  return (
    <div className={linkPreviewContainer}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
      <figure className={linkPreview} data-hook={LINK_PREVIEW_VIEWER} onClick={onLinkPreviewClick}>
        {thumbnailUrl && (
          <Image
            containerProps={{ className: linkPreviewImage }}
            uri={thumbnailUrl}
            width={400}
            height={200}
            displayMode="fill"
            alt={title}
          />
        )}
        <section className={linkPreviewInfo}>
          <div className={linkPreviewUrl} dir="auto">
            {getUrlForDisplay(getHost(link?.url) || link?.url || '')}
          </div>
          <figcaption className={linkPreviewTitle} dir="auto">
            {title}
          </figcaption>
          {description && (
            <div className={linkPreviewDescription} dir="auto">
              {description}
            </div>
          )}
        </section>
      </figure>
    </div>
  );
};
